import React from 'react';
import classNames from 'classnames'
import { Link } from '../../lib/reactRouterWrapper';
import { slugify } from '@/lib/utils/slugify';
import { Typography } from "./Typography";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

export const sectionTitleStyle = (theme: ThemeType) => ({
  margin: 0,
  ...theme.typography.headerStyle,
  fontSize: "2.3rem",
});

const styles = defineStyles('SectionTitle', (theme: ThemeType) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 24,
    paddingBottom: 8,
  },
  noTopMargin: {
    marginTop: 0
  },
  noBottomPadding: {
    paddingBottom: 0
  },
  title: sectionTitleStyle(theme),
  children: {
    ...theme.typography.commentStyle,
    [theme.breakpoints.down('sm')]: {
      marginRight: 8,
      marginLeft: 16,
    },
  }
}), { stylePriority: -1 })

// TODO: figure out what to do when title isn't a string. It currently returns
// undefined, which prevents anchor links from working 
export const getAnchorId = (anchor: string|undefined, title: React.ReactNode) => {
  if (anchor) {
    return anchor;
  }
  if (typeof title === 'string') {
    return slugify(title);
  }
}

export type SectionTitleProps = {
  children?: React.ReactNode,
  titleClassName?: string,
  rootClassName?: string,
  title: React.ReactNode,
  noTopMargin?: boolean,
  noBottomPadding?: boolean,
  centered?: boolean,
  anchor?: string,
  href?: string,
}

// This is meant to be used as the primary section title for the central page layout (normally used in conjunction with SingleColumnSection){}
const SectionTitle = ({title, noTopMargin, noBottomPadding, centered, anchor, href, children, titleClassName, rootClassName}: SectionTitleProps) => {
  const classes = useStyles(styles);

  return (
    <div className={classNames(classes.root, rootClassName, {[classes.noTopMargin]: noTopMargin, [classes.noBottomPadding]: noBottomPadding} )}>
      <Typography
        id={getAnchorId(anchor, title)}
        variant='display1'
        className={classNames(classes.title, titleClassName)}
      >
        {href
          ? <Link to={href}>{title}</Link>
          : title
        }
      </Typography>
      {!centered && <div className={classes.children}>{ children }</div>}
    </div>
  )
}

export default SectionTitle;


